import type { WorkOrderDetail, WorkOrderList, WorkOrderStatus } from '../../api/types'

export const BOARD_COLUMNS: { status: WorkOrderStatus; label: string }[] = [
  { status: 'open', label: 'Abierta' },
  { status: 'assigned', label: 'Asignada' },
  { status: 'in_progress', label: 'En curso' },
  { status: 'done', label: 'Finalizada' },
  { status: 'verified', label: 'Verificada' },
  { status: 'cancelled', label: 'Cancelada' },
]

/** Spanish label of a work-order status (feminine: "orden"). */
export function workOrderStatusLabel(status: string | null | undefined): string {
  return BOARD_COLUMNS.find((c) => c.status === status)?.label ?? (status ? status.replace(/_/g, ' ') : '—')
}

export function boardColumns(orders: WorkOrderList[]) {
  return BOARD_COLUMNS.map((c) => ({ ...c, items: orders.filter((o) => o.status === c.status) }))
}

const LABELS: Record<string, string> = {
  assigned: 'Asignar',
  in_progress: 'Iniciar trabajo',
  done: 'Marcar como finalizada',
  verified: 'Verificar',
  cancelled: 'Cancelar orden',
  open: 'Reabrir',
}

export interface TransitionAction {
  to: WorkOrderStatus
  label: string
  needsAssignee: boolean
  needsCompletionNotes: boolean
  danger: boolean
}

/** The server decides what is allowed (role and state); the UI only adds what each step needs. */
export function transitionActions(order: Pick<WorkOrderDetail, 'allowed_transitions' | 'completion_notes' | 'assignee'>): TransitionAction[] {
  return order.allowed_transitions.map((to) => ({
    to: to as WorkOrderStatus,
    label: LABELS[to] ?? to,
    needsAssignee: to === 'assigned' && !order.assignee,
    needsCompletionNotes: to === 'done' && !order.completion_notes.trim(),
    danger: to === 'cancelled',
  }))
}
